import {Component, OnInit, signal} from '@angular/core';
import {RequestRestorePasswordState} from './request-restore-password-state.enum';
import {FormControl, FormGroup, ReactiveFormsModule, Validators} from '@angular/forms';
import {AuthenticationService} from "../../services/auth/authentication.service";
import {VvrIconComponent} from "../../vvr-icon/vvr-icon.component";
import {MatError, MatFormField, MatInput, MatLabel} from "@angular/material/input";
import {MatButton} from "@angular/material/button";
import {RouterLink} from "@angular/router";

@Component({
    selector: 'app-request-restore-password',
    templateUrl: './request-restore-password.component.html',
    styleUrls: ['./request-restore-password.component.scss'],
    imports: [
        VvrIconComponent,
        ReactiveFormsModule,
        MatFormField,
        MatLabel,
        MatInput,
        MatError,
        MatButton,
        RouterLink
    ]
})
export class RequestRestorePasswordComponent implements OnInit {

    public RequestRestorePasswordState = RequestRestorePasswordState;

    form = new FormGroup({
        email: new FormControl('', [Validators.required, Validators.email])
    });
    public readonly requestState = signal<RequestRestorePasswordState>(RequestRestorePasswordState.FillInEmail);

    constructor(private authService: AuthenticationService) {
    }

    ngOnInit() {
    }

    requestPasswordEmail() {
        this.requestState.set(RequestRestorePasswordState.SendingEmail);
        this.authService.requestRestorePassword(this.form.value.email).then((response) => {
            this.requestState.set(RequestRestorePasswordState.SendedEmail);
        }, () => {
            this.requestState.set(RequestRestorePasswordState.SendEmailFail);
        });
    }

}
